<template>
  <MetricCard
    apiEndpoint="/tiktok/conversions"
    metricName="Conversions"
    :formatData="formatData"
    srcName="TikTok"
  />
</template>

<script setup>
import { formatNumber } from '@/utils/helperFunctions';
import MetricCard from '@/components/MetricCard.vue';

const formatData = (data) => formatNumber(data.data);
</script>
